export var newPayment = {
    uniqueId: '',
    currency: "INR",
    amount: 0
};

export var newProduct = {
    userId: '',
    uniqueId: '',
    ProductName: '',
    Compostions: '',
    ProductDescription: '',
    ProductStatus: '',
    keywords: ''
};

export var newEvent = {
    userId: '',
    uniqueId: '',
    eventName: '',
    eventType: '',
    location: '',
    eventStatus: '',
    eventDescription: ''
};

export var sportEvent = {
    userId: '',
    uniqueId: '',
    tournamentName: '',
    organizerName: '',
    location: '',
    eventStatus: '',
    eventDescription: ''
};

export var filters = {
    Compostions: '0',
    productTitleOrKeywords: '0',
    sortDirection: 'desc'
};

export var newProductAlert = {
    uid: '',
    uniqueId: '',
    alertName: '',
    Compostions: '',
    keywords: '',
    repeat: '',
    acceptTerms: false,
    createAt: new Date(),
    modifyAt: new Date()
};

export var applyProductModel = {
    userId: '',
    employerId: '',
    uniqueId: '',
    productId: '',
    acceptTerms: false,
    ProductName: '',
    storeName: '',
    motivationLetterPath: '',
    applicantName: '',
    applicantEmail: '',
    applicantMobile: '',
    applicationStatus: ''
}

export var topSearchSkillModel = {
    id: 0,
    uniqueId: '',
    searchField: '',
    createdAt: new Date()
};